import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
import { SourceType } from '../SourceType'

export interface HealthRedeclaration {
  tag: TransactionType.HEALTH_DECLARATION
  source: SourceType
  clientName: string
  clientNumber: string
}

export const HealthRedeclaration = (
  detail: api.HealthDeclaration,
  clientName: string,
  clientNumber: string
): HealthRedeclaration => {
  return {
    tag: TransactionType.HEALTH_DECLARATION,
    source: detail.source as SourceType,
    clientName,
    clientNumber
  }
}
